import { useCallback } from 'react';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { DateTimeUtcService, DurationService, useAppClockService } from '@mews/framework';
import { getCurrentEnterpriseOperationalEditableHistoryWindow } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';

export const useIsAvailabilityBlockEditable = () => {
    const operationEditableHistoryWindow = useCommanderSelector((state) => {
        const duration = getCurrentEnterpriseOperationalEditableHistoryWindow(state);
        return DurationService.asSeconds(DurationService.parse(duration));
    });

    const appClockService = useAppClockService();

    const isAvailabilityBlockEditable = useCallback(
        ({ endUtc }: AvailabilityBlock) => {
            const nowUtc = appClockService.getAppNowUtc();

            const secondsDiff = DateTimeUtcService.diffSeconds(DateTimeUtcService.parse(endUtc), nowUtc);

            return secondsDiff >= -operationEditableHistoryWindow;
        },
        [operationEditableHistoryWindow, appClockService]
    );

    return isAvailabilityBlockEditable;
};
